import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  isTagsLoading: false,
  isActiveTagsLoading: false,
  isTagStatusesLoading: false,
  isTagTypesLoading: false,
  isTagCategoriesLoading: false,
  isAvailableTagLoading: false,
  isPlatformsLoading: false,
  error: null,
  tags: null,
  platforms: null,
  activeTags: null,
  tagstatuses: null,
  tagcategories: null,
  tagtypes: null,
  available_tags: null,
};

const slice = createSlice({
  name: 'tag',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    startTagsLoading(state) {
      state.isTagsLoading = true;
    },
    startActiveTagsLoading(state) {
      state.isActiveTagsLoading = true;
    },
    startTagStatusesLoading(state) {
      state.isTagStatusesLoading = true;
    },
    startTagTypesLoading(state) {
      state.isTagTypesLoading = true;
    },
    startTagCategoriesLoading(state) {
      state.isTagCategoriesLoading = true;
    },
    startAvailableTagLoading(state) {
      state.isAvailableTagLoading = true;
    },
    startPlatformLoading(state) {
      state.isPlatformsLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isTagsLoading = false;
      state.isActiveTagsLoading = false;
      state.isTagStatusesLoading = false;
      state.isTagTypesLoading = false;
      state.isTagCategoriesLoading = false;
      state.isAvailableTagLoading = false;
      state.isPlatformsLoading = false;
      state.error = action.payload;
    },
    // GET TAGS
    setTags(state, action) {
      state.isTagsLoading = false;
      state.tags = action.payload;
    },
    // GET TAGS
    setActiveTags(state, action) {
      state.isActiveTagsLoading = false;
      state.activeTags = action.payload;
    },
    // GET TAGSTATUSES
    setTagStatuses(state, action) {
      state.isTagStatusesLoading = false;
      state.tagstatuses = action.payload;
    },
    // GET TAGTYPES
    setTagTypes(state, action) {
      state.isTagTypesLoading = false;
      state.tagtypes = action.payload;
    },
    // GET TAGCATEGORIES
    setTagCategories(state, action) {
      state.isTagCategoriesLoading = false;
      state.tagcategories = action.payload;
    },
    // GET AVAILABLETAGS
    setAvailableTag(state, action) {
      state.isAvailableTagLoading = false;
      state.available_tags = action.payload;
    },
    // GET PLATFORMS
    setPlatforms(state, action) {
      state.isPlatformsLoading = false;
      state.platforms = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  startTagsLoading,
  startActiveTagsLoading,
  startTagStatusesLoading,
  startTagTypesLoading,
  startTagCategoriesLoading,
  startAvailableTagLoading,
  startPlatformLoading,
  hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getTags(url = '/admin/tag/tags') {
  return async () => {
    dispatch(slice.actions.startTagsLoading());
    try {
      const response = await axios.get(url);
      dispatch(slice.actions.setTags(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getPlatforms(url = '/dropdown/tag/tag_scan_platforms') {
  return async () => {
    dispatch(slice.actions.startPlatformLoading());
    try {
      const response = await axios.get(url);
      dispatch(slice.actions.setPlatforms(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAvailableTag(url = '/admin/tag/available_tags', params) {
  return async () => {
    dispatch(slice.actions.startAvailableTagLoading());
    try {
      const response = await axios.get(url, {
        params,
      });
      dispatch(slice.actions.setAvailableTag(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAvailableTagLocation(url = '/dropdown/location/tag_available_locations', params) {
  return async () => {
    dispatch(slice.actions.startAvailableTagLoading());
    try {
      const response = await axios.get(url, {
        params,
      });
      dispatch(slice.actions.setAvailableTag(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAvailableTagJob(url = '/admin/job/dropdown/tag_available_Jobs', params) {
  return async () => {
    dispatch(slice.actions.startAvailableTagLoading());
    try {
      const response = await axios.get(url, {
        params,
      });
      dispatch(slice.actions.setAvailableTag(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAvailableTagInventory(url = '/admin/assets/dropdown/tag_available_inventorys', params) {
  return async () => {
    dispatch(slice.actions.startAvailableTagLoading());
    try {
      const response = await axios.get(url, {
        params,
      });
      dispatch(slice.actions.setAvailableTag(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAvailableTagToolKitsItems(url = '/admin/toolkit/dropdown/tag_available_kit_items', params) {
  return async () => {
    dispatch(slice.actions.startAvailableTagLoading());
    try {
      const response = await axios.get(url, {
        params,
      });
      dispatch(slice.actions.setAvailableTag(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAvailableTagResource(url = '/admin/resource/dropdown/tag_available_resources', params) {
  return async () => {
    dispatch(slice.actions.startAvailableTagLoading());
    try {
      const response = await axios.get(url, {
        params,
      });
      dispatch(slice.actions.setAvailableTag(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAvailableTagToolkit(url = '/admin/toolkit/dropdown/tag_available_toolkits', params) {
  return async () => {
    dispatch(slice.actions.startAvailableTagLoading());
    try {
      const response = await axios.get(url, {
        params,
      });
      dispatch(slice.actions.setAvailableTag(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAvailableTagFleet(url = '/admin/fleet/dropdown/tag_available_fleets', params) {
  return async () => {
    dispatch(slice.actions.startAvailableTagLoading());
    try {
      const response = await axios.get(url, {
        params,
      });
      dispatch(slice.actions.setAvailableTag(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAvailableTagDocument(url = '/dropdown/document/tag_available_documents', params) {
  return async () => {
    dispatch(slice.actions.startAvailableTagLoading());
    try {
      const response = await axios.get(url, {
        params,
      });
      dispatch(slice.actions.setAvailableTag(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAvailableTagEquipment(url = '/admin/equipment/dropdown/tag_available_equipments', params) {
  return async () => {
    dispatch(slice.actions.startAvailableTagLoading());
    try {
      const response = await axios.get(url, {
        params,
      });
      dispatch(slice.actions.setAvailableTag(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getActiveTags() {
  return async () => {
    dispatch(slice.actions.startActiveTagsLoading());
    try {
      const response = await axios.get(`/admin/tag/tags`, {
        params: {
          status: 'available',
        },
      });
      dispatch(slice.actions.setActiveTags(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTagStatuses() {
  return async () => {
    dispatch(slice.actions.startTagStatusesLoading());
    try {
      const response = await axios.get(`/admin/tag/tag_statuses`);
      dispatch(slice.actions.setTagStatuses(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getModuleTagStatuses() {
  return async () => {
    dispatch(slice.actions.startTagStatusesLoading());
    try {
      const response = await axios.get(`/admin/tag/module_tag_statuses`);
      dispatch(slice.actions.setTagStatuses(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTagCategories() {
  return async () => {
    dispatch(slice.actions.startTagCategoriesLoading());
    try {
      const response = await axios.get(`/admin/tag/tag_categories`);
      dispatch(slice.actions.setTagCategories(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTagTypes() {
  return async () => {
    dispatch(slice.actions.startTagTypesLoading());
    try {
      const response = await axios.get(`/admin/tag/tag_types`);
      dispatch(slice.actions.setTagTypes(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
